import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';
import { TicketForwardUserMappingService } from 'src/app/services/ticketforwardusermapping.service';

@Component({
  selector: 'app-ticketforwardusermapping',
  templateUrl: './ticketforwardusermapping.component.html',
  styleUrls: ['./ticketforwardusermapping.component.scss'],
})
export class TicketforwardusermappingComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = ['userName', 'forwardToUsers', 'actions'];
  goDataGrid: any[];
  isShow: boolean;
  actionId: any;
  resultdata: any;
  loading: boolean;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  controlAccess: any;

  constructor(
    private userSessionService: UserSessionService,
    private router: Router,
    private ticketForwardUserMappingService: TicketForwardUserMappingService
  ) {
    this.controlAccess = this.userSessionService.getPageUrl(this.router.url);
  }

  ngOnInit() {
    this.get();
  }

  get() {
    this.loading = true;
    this.ticketForwardUserMappingService.getAll(true).subscribe((res: any) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.goDataGrid = res;
      this.loading = false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onRefresh() {
    this.searchInput.nativeElement.value = '';
    this.get();
  }

  add() {
    this.isShow = true;
    this.actionId = '0';
    this.resultdata = '';
  }

  editTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '1';
    this.resultdata = resultdata;
  }

  viewTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '2';
    this.resultdata = resultdata;
  }

  handelBack(event) {
    const val = event.value;
    this.isShow = val;
    this.get();
  }
}
